export default "__VITE_ASSET__c4d96562__"